var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogressTicketIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 21C17.9706 21 22 16.9706 22 12C22 7.02944 17.9706 3 13 3C8.02944 3 4 7.02944 4 12C4 16.9706 8.02944 21 13 21Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5508 12.3549C16.3918 12.919 15.64 13.3176 14.1367 14.1148C12.6832 14.8854 11.9566 15.2707 11.371 15.1159C11.1289 15.0518 10.9083 14.9302 10.7304 14.7627C10.3 14.3574 10.3 13.5715 10.3 11.9996C10.3 10.4278 10.3 9.64177 10.7304 9.23656C10.9083 9.06904 11.1289 8.94742 11.371 8.88338C11.9566 8.7285 12.6832 9.11382 14.1367 9.88445C15.64 10.6816 16.3918 11.0803 16.5508 11.6443C16.6164 11.8771 16.6164 12.1221 16.5508 12.3549Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressTicketIc);
export default __webpack_public_path__ + "static/media/inprogress_ticket_ic.6a164e50c6fee9f834642868983f2e17.svg";
export { ForwardRef as ReactComponent };